import './_styles.scss';
import React from "react";

import Price from './Price';
import Brands from './Brand';
import Rating from './Rating';
import Availability from './Availability';
import { FiFilter } from 'react-icons/fi';

export default ({ current_filters, products = [], onFilter }) => {

  const [visibility, toggle_visibility] = React.useState('hidden');

  const { brands = [], pricing = {}, out_of_stock } = current_filters || {};

  const product_brands = [...new Set(products.map(a => a.vendor))];

  /**
   * @param {number | any[]} value
   */
  const update_filter = (filter = '', value) => {

    update_visibility();

    return onFilter(filter, value);

  }

  const update_visibility = () => {

    const new_value = visibility === 'hidden' ? 'visible' : 'hidden';

    return toggle_visibility(new_value);

  }

  const on_select_brand = (name = '') => {

    let new_filter = [];

    const selected_brands = [...brands];

    const selected = selected_brands.includes(name);

    if (!selected) new_filter = [...selected_brands, name];

    if (!!selected) new_filter = selected_brands.filter(a => a !== name);

    return update_filter('brands', [...new_filter]);

  }

  const on_change_filter = (filter = '', value = 0) => update_filter(filter, value);

  const filter_count = Object.keys(current_filters).map(a => {

    const value = current_filters[a];

    if (a === 'pricing' && (value.min > 0 || value.max > 0)) return 1;

    if (a === 'min_rating' && value !== 0) return 1;

    if (a === 'out_of_stock' && !value) return 1;

    if (a === 'brands') return value.length;

    return 0;

  }).reduce((a, b) => (a + b), 0);

  return (
    <div className='Section-Catalog-Filters'>

      <div className="mobile-icons noselect">

        <div className="toggle-btn" onClick={update_visibility}>
          <FiFilter className='icon' />
          <div className="label">Filters</div>
        </div>

        <div className="filter-count">{filter_count}</div>

      </div>

      <div className={`Section-Wrapper ${visibility}`}>

        <Brands
          selected={brands}
          data={product_brands}
          onSelect={on_select_brand}
        />

        <Price
          pricing={pricing}
          onChangeEvent={on_change_filter}
        />

        <Rating />

        <Availability
          value={out_of_stock}
          onSelect={on_change_filter}
        />

      </div>
    </div>
  )
}
